export default __webpack_public_path__ + "static/media/projectimg2.ddca79dd.png";